export const FIND_EDOK_FORMS_FAILURE = 'FIND_EDOK_FORMS_FAILURE';

export const findEdokFormsFailure = ({ error, request }) => ({
    type: FIND_EDOK_FORMS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});